import FlexContainer from 'components/common/FlexContainer';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled(FlexContainer)({
  textAlign: 'center',
  margin: '80px 12%',
  gap: 20,
  [mobileMediaQuery]: {
    margin: '80px 20px',
  },
});

export const Heading = styled.div({
  fontSize: 26,
  lineHeight: '30px',
});

export const Text = styled.div({
  lineHeight: '20px',
});
